import React from 'react';
import uuidv4 from 'uuid/v4';

export const EditorSessionIdContext = React.createContext({
  editorSessionId: '',
  refreshEditorSessionId: () => void 0,
});

export const useEditorSessionId = () => React.useContext(EditorSessionIdContext);

export const EditorSessionIdProvider: React.FC<{ initialEditorSessionId: string }> = ({
  children,
  initialEditorSessionId,
}) => {
  const [editorSessionId, setEditorSessionId] = React.useState(initialEditorSessionId);
  const refreshEditorSessionId = React.useCallback(() => {
    setEditorSessionId(uuidv4());
  }, []);

  return (
    <EditorSessionIdContext.Provider value={{ editorSessionId, refreshEditorSessionId }}>
      {children}
    </EditorSessionIdContext.Provider>
  );
};
